<template>
    <vx-card class="list-view-item overflow-hidden" v-on="$listeners">

        <template slot="no-body">
            <div class="vx-row item-details no-gutter">

              <div class="vx-col item-img-container bg-white flex items-center justify-center cursor-pointer product-image"
                   v-bind:style="{ 'background-image': 'url(' + item.photoUrl + ')' }">
              </div>
                <!-- ITEM NAME & DESC COL -->
                <div class="vx-col item-content">
                    <div class="p-4 pt-6">
                        <slot name="item-meta">
                            <h6 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer" @click="navigate_to_detail_view">{{ item.name }}</h6>
                            <p class="text-sm mb-4"><span class="font-semibold cursor-pointer">{{ item.section.name }}</span></p>
                            <p class="item-description text-sm">{{ item.description }}</p>
                        </slot>
                    </div>
                </div>

                <!-- PURCHASE COL -->
                <div class="vx-col flex items-center item-price border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0 border-left-only">

                    <div class="p-2 flex flex-col w-full">

                        <div class="my-6">
                            <h5 :key="item.id" class="font-bold text-center">${{ formatPrice(calculatePrice(item)) }}</h5>

                        </div>

                        <!-- SLOT: ACTION BUTTONS -->
                        <slot name="action-buttons" />
                    </div>
                </div>
            </div>
        </template>

    </vx-card>
</template>

<script>
export default{
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    },
    isMobile () {
      return this.$store.state.api.isMobile
    }
  },
  methods: {
    calculatePrice (priceitem) {
      const item = JSON.parse(JSON.stringify(priceitem))
      if (item.size) {
        item.price = item.size.selected_value.price
      }
      item.hasModifiers.forEach(function (key) {

        if (typeof key.modifier.selected_value !== 'undefined') {
          if (Array.isArray(key.modifier.selected_value)) {
            key.modifier.selected_value.forEach(function (mod_val) {
              item.price = Number(item.price) + Number(mod_val.price)
            })
          } else {
            item.price = Number(item.price) + Number(key.modifier.selected_value.price)
          }

        }
      })
      return item.price * item.quantity
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart (item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
    },
    cartButtonClicked (item) {
      this.isInCart(item.objectID) ? this.$router.push('/apps/eCommerce/checkout').catch(() => {}) : this.additemInCart(item)
    },
    navigate_to_detail_view () {
      this.$router.push({name: 'ecommerce-item-detail-view', params: {item_id: this.item.id }})
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);


        .grid-view-img{
            opacity: 0.9;
        }
    }
  .item-img-container{
    background-position: center;
    background-size: cover;
    min-height: 100px;
  }
  .border-left-only {
    border-width: 0 0 0 1px !important;
  }

  .item-details {
    .item-img-container {
      flex-grow:1;
      min-width: 80px;
    }
    .item-content {
      flex-grow:2;
      max-width: 60%;
      min-width: 60%;
    }
    .item-price {
      flex-grow:1;
    }
  }
}
.mobile .list-view-item {

}
</style>
